module.exports = __webpack_public_path__ + "static/media/armarios-ciudadela.270cc4ba.png";